import { createSelector } from 'reselect';
import first from 'lodash/first';

import locale from '../locale';

const localeSelector = createSelector(state => state, () => {
	const language = first(navigator.language.split('_'));
	if (locale[language]) {
		return locale[language];
	}
	return locale.en;
});

export { localeSelector };
export default localeSelector;



// WEBPACK FOOTER //
// ./src/selectors/locale.js